import type { LanguageCode } from '@repo/domain';
import { isApplicationMode } from '@repo/env-variables';
import { createStore, persist } from '@repo/zustand';

import { resolveLanguage } from '@shared/utils/resolveLanguage';

interface State {
  language: LanguageCode;
  setLanguage: (language: LanguageCode) => void;
}

export const useLanguageStore = createStore<State>({
  name: 'LanguageStore',
  isDev: isApplicationMode('dev'),
})(
  persist(
    (set, get) => ({
      language: resolveLanguage(undefined, undefined),
      setLanguage: (language: LanguageCode) => {
        if (get().language === language) return;
        set({ language });
      },
    }),
    { name: 'language-storage-v1' }
  )
);
